import { Container, Row, Col, Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { root_url } from '../setting';

const MakeQuest = ({ history }) => {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [pw, setPw] = useState('');
  const [rePw, setRePw] = useState('');
  const [content, setContent] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) {
      setIsAdmin(true);
    }
  }, []);

  const onClickSubmit = () => {
    if (pw !== rePw) {
      alert('비밀번호 확인이 일치하지 않습니다.');
      return;
    }
    const data = {
      title,
      content,
      author,
      passwd: pw,
      mimeType: 'text/plain',
    };
    console.log(data);

    axios({
      method: 'post',
      url: `${root_url}/api/qna/question`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        // console.log(res);
        history.push({
          pathname: `/dashboard/qna?pageNo=1`,
          state: { post: data },
        });
        window.location.reload();
      })
      .catch((e) => console.log(e));
  };
  return (
    <div>
      <h1 className="mt-3 mb-3">질문 작성</h1>
      <p>
        대청호마라톤 운영과 관련없는 질문은 관리자 임의로 삭제할 수 있습니다
      </p>
      <Row className="p-2">
        <Col>
          <div className="form-floating">
            <input
              className="form-control"
              placeholder=" " //이래야 form-floating animation 적용됨
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            ></input>
            <label>제목</label>
          </div>
        </Col>
      </Row>
      <Row className="p-2">
        <Col>
          <div className="form-floating">
            <input
              className="form-control"
              placeholder=" "
              type="text"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            ></input>
            <label>작성자 성명</label>
          </div>
        </Col>
      </Row>
      <Row className="p-2">
        <Col>
          <div className="form-floating">
            <input
              className="form-control"
              placeholder=" "
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
            ></input>
            <label>비밀번호</label>
          </div>
        </Col>
        <Col>
          <div className="form-floating">
            <input
              className="form-control"
              placeholder=" "
              type="password"
              value={rePw}
              onChange={(e) => setRePw(e.target.value)}
            ></input>
            <label>비밀번호 확인</label>
          </div>
        </Col>
      </Row>
      <div className="form-floating p-2">
        <textarea
          className="form-control h-25"
          placeholder=" "
          rows="10"
          maxLength="1000"
          style={{ resize: 'none', overflowY: 'hidden' }}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        ></textarea>
        <label>내용</label>
      </div>
      <Row className="text-center mt-4">
        <Col
          xs={{ span: '3', offset: '2' }}
          className="p-1 cursor-pointer rounded-pill bg-custom-color text-white"
          onClick={onClickSubmit}
        >
          작성하기
        </Col>
        <Col
          xs={{ span: '3', offset: '2' }}
          className="p-1 cursor-pointer rounded-pill bg-custom-grey"
          onClick={() => {
            if (isAdmin) {
              history.push('/admin/board/qna?pageNo=1');
            }
            history.push('/dashboard/qna?pageNo=1');
          }}
        >
          목록으로
        </Col>
      </Row>
    </div>
  );
};
export default MakeQuest;
